import type { Idioma } from '../../i18n/configuracion';

/**
 * La bandera de cada idioma, dibujada.
 *
 * ## Por qué SVG y no el emoji
 *
 * Porque **el emoji de bandera no existe en Windows**: el sistema lo dibuja como dos letras
 * —«AR», «US»— y la mitad de los comercios lo vería así. Tres rectángulos de colores son veinte
 * líneas y se ven igual en todos lados.
 *
 * Son ilustrativas y llevan `aria-hidden`: el nombre del idioma está escrito al lado, y un lector
 * de pantalla que además anuncie «bandera de Argentina» dice dos veces lo mismo.
 */
export function Bandera({
  idioma,
  className = 'h-3.5 w-5',
}: {
  readonly idioma: Idioma;
  readonly className?: string;
}): React.ReactElement {
  const marco = 'rounded-[2px] ring-1 ring-black/10';

  if (idioma === 'en') {
    return (
      <svg viewBox="0 0 20 14" className={`${className} ${marco}`} aria-hidden>
        <rect width="20" height="14" fill="#b22234" />
        {[1, 3, 5, 7, 9, 11].map((y) => (
          <rect key={y} y={y} width="20" height="1" fill="#fff" />
        ))}
        <rect width="9" height="7" fill="#3c3b6e" />
      </svg>
    );
  }

  if (idioma === 'pt-BR') {
    return (
      <svg viewBox="0 0 20 14" className={`${className} ${marco}`} aria-hidden>
        <rect width="20" height="14" fill="#009b3a" />
        <path d="M10 1.5 18.5 7 10 12.5 1.5 7Z" fill="#fedf00" />
        <circle cx="10" cy="7" r="3" fill="#002776" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 20 14" className={`${className} ${marco}`} aria-hidden>
      <rect width="20" height="14" fill="#74acdf" />
      <rect y="4.667" width="20" height="4.666" fill="#fff" />
      <circle cx="10" cy="7" r="1.6" fill="#f6b40e" />
    </svg>
  );
}
